import { ModelFactory } from "../../ModelFactory";

export class ReportedTenant {
  constructor(
    public readonly tenantId: string,
    public readonly tenantName: string,
    public readonly value: number,
  ) {
  }
}

class ReportedTenantFactory extends ModelFactory<ReportedTenant> {
  protected fromJson(json: any): ReportedTenant {
    return new ReportedTenant(
      json['tenant_id'],
      json['tenant_name'],
      json['value'],
    );
  }
}
export const reportedTenantFactory = new ReportedTenantFactory();
